import { useEffect } from "react";

let activeLockCount = 0;
let previousOverflow = "";
let previousPaddingRight = "";

const useBodyScrollLock = (isLocked) => {
  useEffect(() => {
    if (typeof document === "undefined" || !isLocked) {
      return undefined;
    }

    const body = document.body;

    if (activeLockCount === 0) {
      previousOverflow = body.style.overflow;
      previousPaddingRight = body.style.paddingRight;

      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      body.style.overflow = "hidden";
      if (scrollBarWidth > 0) {
        body.style.paddingRight = `${scrollBarWidth}px`;
      }
    }

    activeLockCount += 1;

    return () => {
      activeLockCount = Math.max(0, activeLockCount - 1);
      if (activeLockCount === 0) {
        body.style.overflow = previousOverflow;
        body.style.paddingRight = previousPaddingRight;
      }
    };
  }, [isLocked]);
};

export default useBodyScrollLock;
